import React, { useState } from 'react';
import LrGrid from 'components/LrGrid/components/Grid';
import LumenLoader from 'components/Loader';
import { columnDefs, exportCellCallback } from './GridDefs';
import { fetchAgentSummaryTable } from 'services/reporting';
import { GridReadyEvent } from 'ag-grid-enterprise';
import { AgentSummaryTableResponse, ReportingTabProps } from 'types/reporting.type';
import { DateRange } from 'components/Input/components/DateRangePickerForm';
import moment from 'moment';
import { getCurrentProgramYears } from 'application/redux/selectors';
import { useSelector } from 'react-redux';
import EmbeddedPowerBIReport from '../../../../../components/Reporting';

const AgentSummaryTable: React.FunctionComponent<ReportingTabProps> = (props) => {
    const { reportName } = props;
    const RENEWAL_REPORT_ID = 'ecdcb863-7d9f-4413-9378-b61ec83cd501';
    const RENEWAL_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';
    const [summaryTableData, setSummaryTableData] = useState<AgentSummaryTableResponse[]>([]);
    const [error, setError] = useState<boolean>();
    const programYears = useSelector(getCurrentProgramYears);
    const firstTreatyDate = programYears
        .map((t1) => moment(t1.effectiveDate, 'MM/DD/YYYY', true))
        .sort((t1, t2) => {
            return t1.isBefore(t2) ? 1 : -1;
        })
        .pop();
    const defaultStart = firstTreatyDate;
    const defaultEnd = moment();

    const fetchSummaryTableData = async (values: DateRange) => {
        try {
            const response = await fetchAgentSummaryTable(values);
            setSummaryTableData(response);
        } catch (e) {
            setError(true);
        }
    };

    const onGridReady = (params: GridReadyEvent) => {
        // fetchSummaryTableData({ startDate: defaultStart, endDate: defaultEnd });
    };

    const renderDataGrid = () => {
        return (
            <LrGrid
                onGridReady={onGridReady}
                gridClassName="ag-theme-balham"
                components={{ lumenLoader: LumenLoader }}
                loadingOverlayComponent="lumenLoader"
                suppressColumnVirtualisation
                animateRows
                columnDefs={columnDefs}
                rowData={summaryTableData}
                autosize={true}
                treeData={true}
                suppressCsvExport={true}
                defaultExcelExportParams={{
                    processCellCallback: exportCellCallback,
                }}
                getDataPath={(data: any) => {
                    return data.hierarchy.split('|');
                }}
                autoGroupColumnDef={{
                    pinned: 'left',
                    lockPosition: true,
                    headerName: 'Name',
                    cellRendererParams: {
                        suppressCount: true,
                    },
                }}
            />
        );
    };

    return (
        <>
            <EmbeddedPowerBIReport
                reportId={RENEWAL_REPORT_ID}
                workspaceId={RENEWAL_WORKSPACE_ID}
                reportName={'Agent Summary'}
                hideFilters
                waitForPrimary
            />
        </>
        // <Book>
        //     <>
        //         <Grid container spacing={1}>
        //             <Grid xs={12}>
        //                 <DateRangePickerForm
        //                     onSubmit={fetchSummaryTableData}
        //                     submitText={'Fetch'}
        //                     defaultStart={defaultStart}
        //                     defaultEnd={defaultEnd}
        //                 />
        //             </Grid>
        //             <Grid xs={12}>
        //                 {error && (
        //                     <ErrorDialog errorTitle={ERRORS.API_ERROR_MSG_TITLE} errorMsg={ERRORS.API_ERROR_MSG_BODY} />
        //                 )}
        //                 {renderDataGrid()}
        //             </Grid>
        //         </Grid>
        //     </>
        // </Book>
    );
};

export default AgentSummaryTable;
